import React from 'react';
import { StandardModal } from '@components/main-components/modals/StandardModal';
import { ModalContext } from '@context/modal';
import type { TopChartsType } from '@pages-shared/topCharts';
import { SmallShare } from './SmallShare';

export function ShareModalTop({ subType }: { subType: TopChartsType }) {
  const { closeCancelModal } = ModalContext.useContainer();

  const url = typeof window !== 'undefined' ? window.location.href : '';

  const body = <SmallShare url={url} type="top" subType={subType} />;

  return (
    <StandardModal
      body={body}
      title="Share"
      closeModal={closeCancelModal}
      bodyWithoutPaddingBottom
    />
  );
}
